import API from './settings'

export const getClosingCauses = (project_code: string): any => {
    return API.get(`/${project_code}/ticket/closing_cause/get_all`);
};

export const getTicketTitles = (project_code: string): any => {
    return API.get(`/${project_code}/ticket/title/get_all`);
};

export const getTicketStatus = (project_code: string): any => {
    return API.get(`/${project_code}/ticket/status/get_all`);
};

export const getTicketPriorities = (project_code: string): any => {
    return API.get(`/${project_code}/ticket/priority/get_all`);
};

export const getTicketCustomFields = (project_code: string): any => {
    return API.get(`/${project_code}/custom_field/ticket/get_all`);
};

export const getTicketCustomFieldTypes = (project_code: string): any => {
    return API.get(`/${project_code}/custom_field/ticket/type/get_all`);
}

export const getElements = (project_code: string): any => {
    return API.get(`/${project_code}/element/get_all`);
};

export const getCompanies = (project_code: string): any => {
    return API.get(`/${project_code}/company/get_all`);
};

export const getAreasByCompany = (company_id: string, project_code: string): any => {
    return API.get(`/${project_code}/company/get_areas/${company_id}`);
};

export const getPersonsByProject = (project_code: string): any => {
    return API.get(`/${project_code}/person/get_by_project`);
};

export const getSites = (project_code: string): any => {
    return API.get(`/${project_code}/site/get_all`);
};

export const getElementTypes = (project_code: string): any => {
    return API.get(`/${project_code}/element/type/get_all`);
};

export const getPersons = (): any => {
    return API.get('/ALL/person/get_all');
};

export const getProfiles = (): any => {
    return API.get('/ALL/user/profile/get_all');
};

export const getNotifTypes = (project_code: string): any => {
    return API.get(`/${project_code}/area/notif/get_all`);
};

export const getTicketNotificationProfiles = (project_code: string): any => {
    return API.get(`/${project_code}/notifications/profile/get_all`);
};